import { useState } from 'react';

/** Light / dark / follow the device. Per device, like notifications. */
export type ThemePref = 'light' | 'dark' | 'system';

// Same key as the boot script in index.html, which applies it before first paint.
const KEY = 'mustertap.theme';

export function getThemePref(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch { return 'system'; }
}

function apply(pref: ThemePref) {
  if (pref === 'system') delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = pref;
}

export function useThemePref(): [ThemePref, (p: ThemePref) => void] {
  const [pref, setPref] = useState(getThemePref);
  function set(p: ThemePref) {
    try {
      if (p === 'system') localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, p);
    } catch { /* private mode: applies for this visit only */ }
    apply(p);
    setPref(p);
  }
  return [pref, set];
}
